import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

interface NoCreditsModalProps {
  onClose: () => void;
}

export default function NoCreditsModal({ onClose }: NoCreditsModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBuy = () => {
    navigate('/dashboard/credits');
  };

  return (
    <>
      <div
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.45)',
          zIndex: 1040,
          backdropFilter: 'blur(2px)',
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          background: '#fff',
          borderRadius: 20,
          padding: '40px 36px',
          maxWidth: 440,
          width: '90%',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        }}
      >
        {/* Icon */}
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: 'rgba(254,90,29,0.1)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          <i className="bi bi-coin" style={{ fontSize: 32, color: '#fe5a1d' }} />
        </div>

        <h4 style={{ fontWeight: 800, marginBottom: 10, color: '#1a1a1a' }}>
          {t('no_credits.title')}
        </h4>
        <p style={{ color: '#666', fontSize: 15, lineHeight: 1.6, marginBottom: 28 }}>
          <Trans i18nKey="no_credits.message" components={[<strong />]} />
        </p>

        <button
          onClick={handleBuy}
          style={{
            width: '100%',
            padding: '14px 24px',
            background: '#fe5a1d',
            color: '#fff',
            border: 'none',
            borderRadius: 12,
            fontSize: 15,
            fontWeight: 700,
            cursor: 'pointer',
            marginBottom: 10,
            transition: 'background 0.18s',
          }}
          onMouseEnter={e => (e.currentTarget.style.background = '#e04e18')}
          onMouseLeave={e => (e.currentTarget.style.background = '#fe5a1d')}
        >
          <i className="bi bi-cart-plus me-2" />
          {t('no_credits.purchase_btn')}
        </button>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '12px 24px',
            background: 'transparent',
            color: '#888',
            border: '1.5px solid #e0e0e0',
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          {t('no_credits.cancel')}
        </button>
      </div>
    </>
  );
}
